export default __webpack_public_path__ + "static/syncstage-built-for-interoperability-714e82c043b87a2bb2e2d68739976962.png";